import { format } from 'date-fns';
import * as Icon from '../../../components/icons';

interface AuthSettingsItemProps {
  title: string;
  description: React.ReactNode;
  fieldType: 'UPDATED' | 'ACTIVATE' | 'INFO';
  actionDate?: Date;
  borderBottom?: boolean;
  actionOnClick: () => void;
}

const AuthSettingsItem = ({ title, description, fieldType, actionDate, borderBottom = false, actionOnClick }: AuthSettingsItemProps) => {
  return (
    <div className={`py-4 ${borderBottom && 'border-b-gray-tertiary border-b'}`} onClick={actionOnClick}>
      <div className='flex cursor-pointer rounded-lg px-4 py-4 hover:bg-[#57CC991A]'>
        <div className='gap-6 max-md:w-[95%] md:w-[65%]'>
          <div className='text-blue-primary text-lg font-bold'>{title}</div>
          <div className='text-blue-primary pt-2.5'>{description}</div>
        </div>
        {actionDate && (
          <div className='text-blue-primary my-auto ml-auto px-12 text-center text-xs'>
            {fieldType === 'UPDATED' ? 'Mis à jour le' : 'Activé le'} {format(actionDate, 'dd/MM/yyy')}
          </div>
        )}
        {['UPDATED', 'ACTIVATE'].includes(fieldType) && (
          <div className='my-auto ml-3 w-[5%] md:hidden'>
            <Icon.ArrowRight />
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthSettingsItem;
